import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b0023d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global space-y-4 text-gray-800" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = { class: "flex space-x-4" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "text-green-600" }
const _hoisted_7 = { class: "flex justify-between items-center" }
const _hoisted_8 = { class: "text-gray-400" }
const _hoisted_9 = { class: "flex space-x-2" }
const _hoisted_10 = { class: "px-4 py-2 space-x-2 border border-gray-200 rounded-3xl flex items-center" }
const _hoisted_11 = { class: "flex justify-between items-center" }
const _hoisted_12 = { class: "flex items-center space-x-2" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "mr-5" }
const _hoisted_15 = {
  key: 0,
  class: "mt-3 text-gray-500"
}
const _hoisted_16 = {
  key: 1,
  class: "mt-3 text-red-500"
}
const _hoisted_17 = {
  key: 3,
  class: "mt-3 text-gray-500"
}

import { ref, watchEffect } from "vue";
import {
  ViewListIcon,
  ExternalLinkIcon,
  PrinterIcon,
  StarIcon as StarIconOutline,
  PaperClipIcon,
  DocumentAddIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@heroicons/vue/outline";
import { StarIcon as StarIconSolid } from "@heroicons/vue/solid";
import Process from "@/types/documents/process/Process";
import ProcessTable from "@/views/documents/process/ProcessTable.vue";
import DocumentStatusLabel from "@/components/documents/DocumentStatusLabel.vue";
import { useStore } from "vuex";
import DocumentDataService from "@/services/documents/document/DocumentDataService";
import { DocumentActions } from "@/store/modules/document/actions";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null,
    title: null,
    attachedFilesCount: null,
    registrationId: null,
    creationDate: null,
    creatorName: null,
    categoryName: null,
    status: null,
    favorite: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  attachedFilesCount: number;
  registrationId: string;
  creationDate: string;
  creatorName: string;
  categoryName: string;
  // processes: Process[];
  status: string;
  favorite: boolean;
}



const extended = ref(false);

const store = useStore();
const processes = ref<Process[]>([]);
const processesLoading = ref(false);
const processesLoadFailed = ref(false);
let processesLoadSequence = 0;

async function loadProcesses() {
  const loadSequence = ++processesLoadSequence;
  processesLoading.value = true;
  processesLoadFailed.value = false;

  try {
    const response = await DocumentDataService.get(props.id);
    if (loadSequence !== processesLoadSequence) return;

    const loadedDocument = response?.data?.data?.document;
    if (String(loadedDocument?.id) !== String(props.id)) {
      throw new Error("Loaded document does not match the requested document");
    }
    processes.value = Array.isArray(loadedDocument.documentProcesses)
      ? loadedDocument.documentProcesses
      : [];
  } catch {
    if (loadSequence !== processesLoadSequence) return;
    processes.value = [];
    processesLoadFailed.value = true;
  } finally {
    if (loadSequence === processesLoadSequence) {
      processesLoading.value = false;
    }
  }
}

async function fetchDocument() {
  extended.value = !extended.value;

  if (extended.value) {
    await loadProcesses();
  }
}

const isFavourite = ref(false);
watchEffect(() => {
  isFavourite.value = props.favorite;
});
async function setFavouriteDocument() {
  await store.dispatch(DocumentActions.SET_FAVOURITE, props.id);
  isFavourite.value = !isFavourite.value;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'DocumentDetails', params: { id: __props.id } }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: `/documents/document/${__props.id}`,
          target: "_blank"
        }, [
          _createVNode(_unref(ExternalLinkIcon), { class: "w-6 h-6 text-primary-300" })
        ], 8, _hoisted_5),
        (_openBlock(), _createBlock(_resolveDynamicComponent(isFavourite.value ? _unref(StarIconSolid) : _unref(StarIconOutline)), {
          class: "w-6 h-6 text-primary-300",
          onClick: setFavouriteDocument
        }))
      ])
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("document.regNumber")) + ": " + _toDisplayString(__props.registrationId), 1),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("document.category")) + ": " + _toDisplayString(__props.categoryName), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(PaperClipIcon), { class: "w-6 h-6 text-green-400" }),
          _createElementVNode("span", null, _toDisplayString(__props.attachedFilesCount), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(DocumentAddIcon), { class: "w-8 h-8 text-gray-600" }),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("document.createdBy")) + " " + _toDisplayString(__props.creationDate) + " / " + _toDisplayString(__props.creatorName), 1)
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "no-underline text-primary-300 font-semibold",
        onClick: _withModifiers(fetchDocument, ["prevent"])
      }, [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("document.status")) + " ", 1),
          _createElementVNode("span", _hoisted_14, [
            _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ChevronUpIcon)), { class: "inline w-4 h-4 ml-2" }, null, 512)), [
              [_vShow, extended.value]
            ]),
            _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ChevronDownIcon)), { class: "inline w-4 h-4 ml-1" }, null, 512)), [
              [_vShow, !extended.value]
            ])
          ]),
          _createVNode(DocumentStatusLabel, { label: __props.status }, null, 8, ["label"])
        ])
      ], 8, _hoisted_13)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["transition-all duration-500 overflow-hidden", { 'max-h-screen': extended.value, 'max-h-0': !extended.value }])
    }, [
      (processesLoading.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t("common.loading")), 1))
        : (processesLoadFailed.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.error")), 1),
              _createElementVNode("button", {
                class: "ml-3 underline",
                type: "button",
                onClick: loadProcesses
              }, _toDisplayString(_ctx.$t("dashboard.retry")), 1)
            ]))
          : (processes.value.length)
            ? (_openBlock(), _createBlock(ProcessTable, {
                key: 2,
                class: "mt-3 border-t-2 border-dashed border-gray-300",
                processes: processes.value
              }, null, 8, ["processes"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t("process.noData")), 1))
    ], 2)
  ]))
}
}

})